"use client";
import { useGlobals } from "@/projectRoot/src/contexts/GlobalsContext";
import HeaderMobile from "./mobile/HeaderMobile";
import HeaderDesktop from "./desktop/HeaderDesktop";
import MenuItemDto from "@/projectRoot/api-client/interfaces/models/content/menu/MenuItem.dto";
import { Language } from "@/projectRoot/routes.config";
import NotificationDto from "@/projectRoot/api-client/interfaces/models/content/Notification.dto";

interface Props {
  menu_items: MenuItemDto[];
  multilang_slugs?: Record<Language, string>;
  notifications?: NotificationDto[];
  route_parameter?: {
    list?: string;
    single?: string;
  }
}

const HeaderWrapper = ({menu_items, multilang_slugs, route_parameter, notifications}: Props) => {

    const {isMobileView} = useGlobals();

  return (
    isMobileView
    ?
    <HeaderMobile menu_items={menu_items} multilang_slugs={multilang_slugs} notifications={notifications} route_parameter={route_parameter} />
    :
    <HeaderDesktop menu_items={menu_items} multilang_slugs={multilang_slugs} notifications={notifications} route_parameter={route_parameter} />
  )
};

export default HeaderWrapper;
